export const SearchParams = {
    ACCOUNT_NUMBER: 'kontonummer',
    STATUS: 'status',
    ACCOUNT_ID: 'kontoid',
    CARD_DETAILS_REDIRECT: 'cardDetailsRedirect',
    CARD_ID: 'cid',
    CARD_TYPE: 'ctype',
    CHANGED_PIN: 'nyPin',
    PIN_DECISION: 'pinDecision',
    CLOSE_ACCOUNT_NUMBER: 'avslutt',
    REASON: 'reason',
    REORDER: 'reorder',
    TRANSFER_TO_ACCOUNT_NUMBER: 'overfoer',
    SHOW_RECEIPT: 'showReceipt',
    lokalbank: {
        RECEIVER: 'receiverAccountNumber',
        KID: 'kid',
        RETURN_URL: 'returnUrl',
    },
} as const;
